export enum MovementType {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND',
    COUNT = 'COUNT',
    ADJUSTMENT = 'ADJUSTMENT',
    DELETE_STOCK_ON_LOCATION = 'DELETE_STOCK_ON_LOCATION',
    STOCK_INCREASE = 'STOCK_INCREASE',
    STOCK_DECREASE = 'STOCK_DECREASE',
}
